import React from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { Modal as CrateModal } from '@tcc/crate';

import SelectOperationModal from '../OperationNotAllowed';
import { EnhancedScoutingForm } from '../../../containers/layers/scouting/EnhancedScoutingForm';
import { RegionNoteForm, RegionReport } from '../../../components/FieldRegionReport';
import { PaywallModal } from '../PaywallModal/PaywallModal';
import { ScoutingForm } from '../../../containers/layers/scouting';
import { ModalType } from '../../../types';

import { useAppSelector } from '../../../utils';
import { getModalShow, getModalSize, getModalType, getModalMode } from '../../../selectors/modalSelectors';
import { closeModal } from '../../../actions/modalActions';

import styles from './Modal.css';
import SilageModal from '../SilageModal/SilageModal';

export type ModalProps = {
  index: number;
  modal?: React.ReactElement;
  className?: string;
};

const getClassName = (modalType?: ModalType): string => {
  if (modalType === ModalType.REGION_REPORT || modalType === ModalType.REGION_NOTE) {
    return styles.regionReportModal;
  }
  if (modalType === ModalType.ENHANCED_SCOUTING_FORM) {
    return styles.enhancedScoutingModal;
  }
  if (modalType === ModalType.SCOUTING_FORM) {
    return styles.scoutingModal;
  }

  return '';
};

export const Modal = ({ modal, index, className }: ModalProps) => {
  const dispatch = useDispatch();
  const show = useAppSelector(state => getModalShow(state, { index }));
  const modalType = useAppSelector(getModalType);
  const modalMode = useAppSelector(getModalMode);
  const size = useAppSelector(getModalSize);
  const modalClassName = getClassName(modalType);

  const isNullModal = modalType === undefined;
  const isScoutingModal = modalType === ModalType.SCOUTING_FORM;
  const isOperationNotAllowedModal = modalType === ModalType.OPERATION_NOT_ALLOWED;
  const isRegionReportModal = modalType === ModalType.REGION_REPORT;
  const isRegionNoteModal = modalType === ModalType.REGION_NOTE;
  const isEnhancedScoutingModal = modalType === ModalType.ENHANCED_SCOUTING_FORM;
  const isPaywall = modalType === ModalType.PAYWALL;
  const isSilageModal = modalType === ModalType.SILAGE;

  if (isPaywall) {
    return (
      <PaywallModal
        show={show}
        modalMode={modalMode}
        onClose={() => { dispatch(closeModal(index)); }}
      />
    );
  }

  return (
    <CrateModal
      className={cx(className, modalClassName)}
      show={show}
      size={size}
    >
      {isNullModal && modal ? React.cloneElement(modal, { index }) : null}
      {isScoutingModal && <ScoutingForm index={index} />}
      {isOperationNotAllowedModal && (
        <SelectOperationModal index={index} />
      )}
      {isRegionReportModal && <RegionReport index={index} />}
      {isRegionNoteModal && <RegionNoteForm index={index} />}
      {isEnhancedScoutingModal && <EnhancedScoutingForm index={index} />}
      {isSilageModal && <SilageModal index={index} onClose={() => { dispatch(closeModal(index)); }}/>}
    </CrateModal>
  );
};
